<template>
    <div class="paybox">
        <div class="title-item">
            <p class="title">{{ $t("message.shop.payList.payType") }}</p>
        </div>
        
        <van-radio-group v-model="payTypeModel">
            <van-cell-group>
                <template v-if="$i18n.locale !== 'en'">
                    <van-cell class="cell global_pointer"
                    v-if="isWx"
                    :title="$t('message.shop.payList.weixinPay')"
                    clickable
                    icon="https://fr-static.shopshops.top/20200328/icon_WeChat_normel@3x.265b6451f3f8e41b.png"
                    @click="paySelect('2')">
                        <template #right-icon>
                            <van-radio shape="square" checked-color="#000" name="2" />
                        </template>
                    </van-cell>
                    <van-cell class="cell global_pointer"
                    v-if="!isWx"
                    :title="$t('message.shop.payList.aliPay')"
                    clickable
                    icon="https://fr-static.shopshops.top/20200622/Alipay@3x.04530ade1aed9f85.png"
                    @click="paySelect('1')">
                        <template #right-icon>
                            <van-radio shape="square" checked-color="#000" name="1" />
                        </template>
                    </van-cell> 
                    <van-cell class="cell global_pointer"
                    :title="$t('message.shop.payList.unionPay')"
                    clickable
                    icon="https://fr-static.shopshops.top/20210121/logo_zh_CN.46cd58bcd83f5dad.png"
                    @click="paySelect('4')">
                        <template #right-icon>
                            <van-radio shape="square" checked-color="#000" name="4" />
                        </template>
                    </van-cell>
                </template>
                <template v-else>
                    <van-cell class="cell global_pointer"
                    title="Credit Card"
                    clickable
                    @click="paySelect('3')">
                        <template #icon>
                            <img class="left-icon" src="@/assets/imgs/order/bankcard.png"/></template>
                        <template #right-icon>
                            <van-radio shape="square" checked-color="#000" name="3" />
                        </template>
                    </van-cell>

                </template>
            </van-cell-group>
        </van-radio-group>
    </div>
</template>

<script>
import { RadioGroup, Radio, Cell, CellGroup } from 'vant';
import {  plateForm } from '@/utils';
const isWx = plateForm().os === 'wxClient';

export default {
    components: {
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
    },
    props: {
        payType: {
            type: String,
            default: () => {
                return '3'
            }
        },
    },
    data(){
        return {
            isWx,
            payTypeModel: 3,
        }
    },
    created(){
        this.payTypeModel =  this.payType;
    },
    methods: {
        paySelect(val){
            this.payTypeModel = val
            this.$emit('paySelect', val);
        } 
    }
}
</script>

<style lang="less" scoped>
.paybox{
    background: #fff;
    padding: 0 10px;
    margin-top: 10px;
    .title-item{
        height: 45px;
        line-height: 45px;
        background-color: #fff;
        font-family: PingFangSC-Regular;
        color: #161a1a;
        padding: 5px 10px 5px 0;
        .title{
            font-size: 16px;
            color: #161a1a;
            letter-spacing: 0;
            text-align: left;
        }
    }
    .cell{
        text-align: left;
        font-size: 14px;
    }
    .left-icon{
        width: 24px;
        height: 24px;
        margin-right: 5px;
    }
}
</style>
